import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import React from 'react';
import ReactDom from 'react-dom';
import ToastManager from './toastManager';
var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';

/**
 * The Toaster manages the interactionsb between
 * the ToasterManger and the toast API.
 */
var Toaster = /*#__PURE__*/_createClass(function Toaster() {
  var _this = this;
  _classCallCheck(this, Toaster);
  this._bindNotify = function (handler) {
    _this.notifyHandler = handler;
  };
  this._bindGetToasts = function (handler) {
    _this.getToastsHandler = handler;
  };
  this._bindCloseAll = function (handler) {
    _this.closeAllHandler = handler;
  };
  this.getToasts = function () {
    return _this.getToastsHandler();
  };
  this.closeAll = function () {
    return _this.closeAllHandler();
  };
  this.notify = function (title) {
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _this.notifyHandler(title, _objectSpread(_objectSpread({}, settings), {}, {
      intent: 'none'
    }));
  };
  this.success = function (title) {
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _this.notifyHandler(title, _objectSpread(_objectSpread({}, settings), {}, {
      intent: 'success'
    }));
  };
  this.warning = function (title) {
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _this.notifyHandler(title, _objectSpread(_objectSpread({}, settings), {}, {
      intent: 'warning'
    }));
  };
  this.danger = function (title) {
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _this.notifyHandler(title, _objectSpread(_objectSpread({}, settings), {}, {
      intent: 'danger'
    }));
  };
  if (!isBrowser) return;
  var container = document.createElement('div');
  container.setAttribute('data-evergreen-toaster-container', '');
  document.body.appendChild(container);
  ReactDom.render( /*#__PURE__*/React.createElement(ToastManager, {
    bindNotify: this._bindNotify,
    bindGetToasts: this._bindGetToasts,
    bindCloseAll: this._bindCloseAll
  }), container);
});
export { Toaster as default };